import {
  DefaultButton,
  Dropdown,
  IDropdownOption,
  IDropdownStyles,
  Stack,
  Text,
  useTheme,
} from '@fluentui/react';
import { InvoiceRow } from 'ap/signing/types';
import { useCommonStyles } from 'common/styles';
import React from 'react';

import { useQuery, useReactiveVar } from '@apollo/client';
import { ExportInvoices } from 'ap/signing/components/ExportInvoices';
import {
  InvoicesSigningSearch,
  InvoicesSigningSearchVariables,
} from 'common/components/Modules/TransactionEdit/graphql/__generated__/InvoicesSigningSearch';
import { TransactionSigningStampPrivileges } from 'common/components/Modules/TransactionEdit/graphql/__generated__/TransactionSigningStampPrivileges';

import STAMP_PRIVILEGES_DATA from '../../../../../common/components/Modules/TransactionEdit/graphql/TransactionSigningStampPrivileges.graphql';
import { CloseButton } from 'common/components/Buttons';
import { globalMode, setGlobalSearchText } from 'utility/cache/ui';
import { FilterArrayType } from 'common/components/Filters';

interface HeaderProps {
  selectedRows: InvoiceRow[];
  invoicesData: InvoicesSigningSearch | undefined;
  variables: InvoicesSigningSearchVariables | undefined;

  refetch: () => void;
  onStamp: () => void;
  defaultDataView: any;
  onDataViewChange: (key: string | number | undefined) => void;
  isHistorySearch: boolean;
  setinvoiceListVisible:
    | React.Dispatch<React.SetStateAction<boolean>>
    | undefined;
  searchFilters: FilterArrayType[];
  isSelectedAllRows: boolean;
  searchTextValue: string | null;
  isSigningSearch: boolean;
  isSearchAllData: boolean;
  filterSupplierId: string | undefined

}
export const Header: React.FC<HeaderProps> = ({
  selectedRows,
  invoicesData,
  refetch,
  onStamp,
  defaultDataView,
  variables,
  onDataViewChange,
  setinvoiceListVisible,
  searchFilters,
  isSelectedAllRows,
  isSigningSearch,
  isHistorySearch,
  isSearchAllData,
  searchTextValue,
  filterSupplierId,
}) => {
  const commonStyles = useCommonStyles();
  const theme = useTheme();
  const globalState = useReactiveVar(globalMode);

  const { data: stampPrivilegesData } =
    useQuery<TransactionSigningStampPrivileges>(STAMP_PRIVILEGES_DATA, {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-only',
    });

  const stampButtonVisible =
    stampPrivilegesData?.transactionSigningStampPrivileges?.isStampingAllowed &&
    !isHistorySearch;

  const dropdownStyles: Partial<IDropdownStyles> = {
    title: {
      border: 0,
      outline: 0,
      borderBottom: `1px solid ${theme.semanticColors.inputBorder}`,
    },
    dropdown: {
      width: 140,
    },
  };
  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      verticalAlign="center"
      className={commonStyles.listTitleContainer}
    >
      <Text variant="xLarge">Accounting Entry</Text>
      <Stack horizontal tokens={{ childrenGap: 10 }}>
        <Dropdown
          placeholder="Select"
          selectedKey={defaultDataView}
          options={defaultDataViewOptions}
          onChange={(_, option) => {
            onDataViewChange(option?.key);
          }}
          styles={dropdownStyles}
        />

        {!setinvoiceListVisible && stampButtonVisible && (
          <DefaultButton
            text="Stamp"
            onClick={onStamp}
            iconProps={{
              iconName: 'StampSmall',
              styles: {
                root: {
                  fill: theme.palette.black,
                },
              },
            }}
          />
        )}
        {selectedRows.length > 0 && (
          <Stack style={{ alignItems: 'flex-end' }}>
            <ExportInvoices
              selectedRows={selectedRows}
              searchFilters={searchFilters}
              isLinkSearch={globalState}
              isSelectedAll={isSelectedAllRows}
              searchRequestInput={
                searchTextValue ? { searchText: [searchTextValue] } : null
              }
              isSigningSearch={isSigningSearch}
              isHistorySearch={isHistorySearch}
              isSearchAllData={isSearchAllData}
              filterSupplierId={filterSupplierId}
            />
          </Stack>
        )}
        {setinvoiceListVisible && (
          <CloseButton
            onClick={() => {
              globalMode(false);
              setinvoiceListVisible(false);
            }}
          />
        )}
      </Stack>
    </Stack>
  );
};

export enum DefaultDataViewEnum {
  all_Transactions = 'ALL_TRANSACTIONS',
  my_Transactions = 'MY_TRANSACTIONS',
}

const defaultDataViewOptions: IDropdownOption[] = [
  {
    key: DefaultDataViewEnum.my_Transactions,
    text: 'My Transactions',
  },
  {
    key: DefaultDataViewEnum.all_Transactions,
    text: 'All Transactions',
  },
];
